var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{ref:"paymentForm",attrs:{"id":"payment-form"}},[_vm._t("card-element",function(){return [_c('div',{attrs:{"id":"card-element"}})]}),_vm._t("card-errors",function(){return [_c('div',{attrs:{"id":"card-errors","role":"alert"}})]}),_c('button',{ref:"submitButtonRef",staticClass:"hide",attrs:{"type":"submit"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }